export const pageRoutes = {
  dashboard: '/',
  manageCandidate: '/manage-candidate',
  manageUser: '/manage-user',
  manageRevenue: '/manage-revenue',
  manageCMS: '/manage-cms',
  manageJob: '/manage-job',
  jobManagement: '/job-management',
  subjects: '/subjects',
  skills: '/skills',
  addQuestions: '/add-questions',
  questions: '/questions',
  assessments: '/assessments',
  createAssessment: '/assessments/create',
  editAssessment: '/assessments/edit',
  candidate: '/candidate',
  employer: '/employer',
  codingChallenge: '/coding-challenge',
  codingProblem: '/coding-problem',
  editCodingProblem: '/edit-coding-problem',
  codingSubmission: '/coding-submission',
  viewTestSubmission: '/view-test-submission',
};
